import { render } from "./habitualSetting.vue?vue&type=template&id=4783b3c6&scoped=true"
import script from "./habitualSetting.vue?vue&type=script&lang=js"
export * from "./habitualSetting.vue?vue&type=script&lang=js"

import "./habitualSetting.vue?vue&type=style&index=0&id=4783b3c6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4783b3c6"]])

export default __exports__